import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { PaperclipIcon } from "lucide-react";
import { cn } from "../../../utils";
import { Button } from "../../base/button/button";
/**
 * The paperclip that opens a file picker for the chat composer.
 *
 * It lives beside `AiChatPanel` rather than inside it because the composer is
 * the host's slot: the button belongs next to the host's own input, while the
 * panel owns the drop zone and the chips.
 *
 * `accept` narrows the picker as a convenience only — a file dialog can always
 * be switched back to "all files", so the real refusals are the client-side
 * pre-check in `useAppChatAttachments` and, behind it, the server.
 */ export function AiChatAttachButton({ onFiles, accept, multiple = true, label = "Attach a file", className, disabled }) {
    const inputRef = React.useRef(null);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Button, {
                type: "button",
                "data-slot": "ai-chat-attach-button",
                variant: "ghost",
                size: "icon-sm",
                disabled: disabled,
                "aria-label": label,
                className: cn("shrink-0", className),
                onClick: ()=>inputRef.current?.click(),
                children: /*#__PURE__*/ _jsx(PaperclipIcon, {
                    "aria-hidden": true
                })
            }),
            /*#__PURE__*/ _jsx("input", {
                ref: inputRef,
                type: "file",
                accept: accept,
                multiple: multiple,
                className: "hidden",
                "data-testid": "ai-chat-attachment-input",
                disabled: disabled,
                onChange: (event)=>{
                    onFiles(Array.from(event.target.files ?? []));
                    // Reset so picking the SAME file twice in a row still fires `change`.
                    event.target.value = "";
                }
            })
        ]
    });
}

//# sourceMappingURL=ai-chat-attach-button.js.map